import { connect } from 'react-redux';
import { selectActiveVenueId } from 'selectors/general';
import ServicesPicker from './ServicesPicker';

const mapStateToProps = state => ({ venueId: selectActiveVenueId(state) });

export default connect(mapStateToProps)(ServicesPicker);
